import * as React from 'react';
import SvgIcon, { SvgIconProps } from '../SvgIcon';

export const MessageIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 22 22" {...props}>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.3333 1.8335H3.66665C2.65831 1.8335 1.83331 2.6585 1.83331 3.66683V20.1668L5.49998 16.5002H18.3333C19.3416 16.5002 20.1666 15.6752 20.1666 14.6668V3.66683C20.1666 2.6585 19.3416 1.8335 18.3333 1.8335Z" fill="#004CCC" />
    </svg>
  </SvgIcon>
);